import { atomWithReset } from 'jotai/utils';

import type { EmailVerificationCode } from '@/types/emailVerification';

/**
 * The email verification code object. The value of the code was sent to the user's email address to verify ownership
 * of the given address.
 */
export const emailVerificationCodeAtom = atomWithReset<EmailVerificationCode>(
  {
    id: '',
    createdAt: '',
    emailAddress: '',
    emailTemplate: '',
    firstName: '',
    respondent: '',
    user: ''
  }
);

/** The current value of the email verification code value input field. */
export const emailVerificationCodeValueAtom = atomWithReset<string>('');

/** The current value of the email verification code value input field. */
export const emailVerificationErrorMessageAtom = atomWithReset<string | null>(null);

/** Whether an email verification email is currently being sent. */
export const isSendingEmailVerificationAtom = atomWithReset<boolean>(false);

/** Whether an API request verifying the email address verification code is currently in progress. */
export const isVerifyingEmailCode = atomWithReset<boolean>(false);

/** Whether the "submit" button for the verification code form is currently disabled. */
export const isVerificationDisabledAtom = atomWithReset<boolean>(true);